<template>
  <div class="settlement-breakdown">
    <div class="title">
      <div class="breakdown">
        Breakdown
      </div>
      <c-button
        @click="downloadPDF"
        variant="primary-outline"
        :id="getElementId('export')"
      >
        <DownloadsIcon />
        {{ "Download Report (.PDF)" }}
      </c-button>
    </div>
    <HtmlToPdf
      :show-layout="false"
      :enable-download="true"
      :filename="'Deposit_Breakdown_' + deposit.id"
      :pdf-quality="2"
      pdf-format="a4"
      pdf-orientation="landscape"
      pdf-content-width="100%"
      ref="html2Pdf"
    >
      <section slot="pdf-content">
        <ExportableDepositBreakdown :deposit="deposit" />
      </section>
    </HtmlToPdf>
  </div>
</template>

<script>
import DepositDto from "@/api/paymentApi";
import {mapGetters} from "vuex";
import DownloadsIcon from "@/components/icons/DownloadsIcon";
import HtmlToPdf from '@/components/common/HtmlToPdf.vue';
import {PendoPrefixes} from "@/app/utils/common/constants";
import ExportableDepositBreakdown from '@/components/deposits/ExportableDepositBreakdown.vue';

export default {
  name: "DepositBreakdown",
  components: { ExportableDepositBreakdown, DownloadsIcon, HtmlToPdf},
  props: {
    deposit: {
      type: DepositDto,
      required: true,
    },
  },
  data: function () {
    return {}
  },
  computed: {
    ...mapGetters('app', ['getMerchantId']),
  },
  methods: {
    downloadPDF() {
      this.$refs.html2Pdf.generatePdf()
    },
    getElementId(id) {
      return PendoPrefixes.CBpay + this.$route.name + '-' + id;
    }
  },
}
</script>

<style lang="scss">
.settlement-breakdown {
  & .title {
    text-align: left;
    font-size: 16px;
    font-weight: $weight-bold;
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;


    & .c-button {
      width: fit-content;
      height: 32px;
      font-style: normal;
      font-weight: 600;
      font-size: 12px;
      line-height: 18px;
      background-color: #e5f3fa;
      border: 1px solid #8ccce6;
      color: #2d6a8a;
      padding-left: 12px;
      padding-right: 12px;

      & svg{
        margin-right: 5px;
      }
    }

    & .c-button__label {
      padding: 0;
    }

    & .c-button:hover {
      color: #2d6a8a;
      background-color: #b5def0;
    }

  }

  & .vue-html2pdf {
    position: relative;
    & .layout-container {
      position: initial !important;
      width: 100% !important;
      height: 100% !important;
      background: none !important;
    }

    & .show-in-pdf-only {
      display: none;
    }
  }
}
</style>